var render = function () {
  var _vm$companyData, _vm$companyData2, _vm$companyData3, _vm$companyData4, _vm$companyData5, _vm$companyData6, _vm$companyData7, _vm$companyData8, _vm$companyData9, _vm$subscriptionExpir, _vm$subscriptionExpir2, _vm$subscriptionExpir3, _vm$subscriptionExpir4, _vm$companyData10, _vm$companyData11, _vm$companyData12, _vm$companyData13, _vm$companyData14;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('b-card', {
    staticClass: "mb-3 p-3"
  }, [_c('b-row', {
    staticClass: "align-items-center text-center text-md-left"
  }, [_c('b-col', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "md": "3"
    }
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s((_vm$companyData = _vm.companyData) === null || _vm$companyData === void 0 ? void 0 : _vm$companyData.name))]), _c('p', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s((_vm$companyData2 = _vm.companyData) === null || _vm$companyData2 === void 0 ? void 0 : _vm$companyData2.email))]), _c('p', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Contact:")]), _vm._v(" " + _vm._s((_vm$companyData3 = _vm.companyData) === null || _vm$companyData3 === void 0 ? void 0 : _vm$companyData3.contact_no))]), (_vm$companyData4 = _vm.companyData) !== null && _vm$companyData4 !== void 0 && _vm$companyData4.website ? _c('p', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Website:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.companyData.website,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.companyData.website))])]) : _vm._e()]), _c('b-col', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "md": "3"
    }
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Package ID:")]), _vm._v(" " + _vm._s((_vm$companyData5 = _vm.companyData) === null || _vm$companyData5 === void 0 ? void 0 : _vm$companyData5.package_id))]), _c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Max Users:")]), _vm._v(" " + _vm._s((_vm$companyData6 = _vm.companyData) === null || _vm$companyData6 === void 0 ? void 0 : _vm$companyData6.max_user) + " ")]), _c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Subscription Expire:")]), _c('span', {
    class: _vm.getSubscriptionStatusClass((_vm$companyData7 = _vm.companyData) === null || _vm$companyData7 === void 0 ? void 0 : _vm$companyData7.subscription_expire_date)
  }, [_vm._v(" " + _vm._s(_vm.formatDateTime((_vm$companyData8 = _vm.companyData) === null || _vm$companyData8 === void 0 ? void 0 : _vm$companyData8.subscription_expire_date)) + " ")])]), (_vm$companyData9 = _vm.companyData) !== null && _vm$companyData9 !== void 0 && _vm$companyData9.referral_id ? _c('p', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Referral ID:")]), _vm._v(" " + _vm._s(_vm.companyData.referral_id) + " ")]) : _vm._e()]), _c('b-col', {
    staticClass: "mb-2 mb-md-0",
    attrs: {
      "md": "3"
    }
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Last Payment:")]), _vm._v(" " + _vm._s((_vm$subscriptionExpir = _vm.subscriptionExpireDate) === null || _vm$subscriptionExpir === void 0 ? void 0 : (_vm$subscriptionExpir2 = _vm$subscriptionExpir.currency) === null || _vm$subscriptionExpir2 === void 0 ? void 0 : _vm$subscriptionExpir2.toUpperCase()) + " " + _vm._s((_vm$subscriptionExpir3 = _vm.subscriptionExpireDate) === null || _vm$subscriptionExpir3 === void 0 ? void 0 : _vm$subscriptionExpir3.amount_paid) + " ")]), _c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Next Payment Date:")]), _vm._v(" " + _vm._s(_vm.formatDateTime((_vm$subscriptionExpir4 = _vm.subscriptionExpireDate) === null || _vm$subscriptionExpir4 === void 0 ? void 0 : _vm$subscriptionExpir4.next_payment_date)) + " ")]), _c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Payment Method:")]), _vm._v(" " + _vm._s(_vm.getPaymentMethodName((_vm$companyData10 = _vm.companyData) === null || _vm$companyData10 === void 0 ? void 0 : _vm$companyData10.payment_method)) + " ")])]), _c('b-col', {
    staticClass: "text-md-right",
    attrs: {
      "md": "3"
    }
  }, [_c('b-badge', {
    staticClass: "p-2",
    attrs: {
      "variant": _vm.getStatusVariant((_vm$companyData11 = _vm.companyData) === null || _vm$companyData11 === void 0 ? void 0 : _vm$companyData11.status)
    }
  }, [_vm._v(" " + _vm._s(_vm.getStatusText((_vm$companyData12 = _vm.companyData) === null || _vm$companyData12 === void 0 ? void 0 : _vm$companyData12.status)) + " ")]), (_vm$companyData13 = _vm.companyData) !== null && _vm$companyData13 !== void 0 && _vm$companyData13.pause_date ? _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_c('strong', [_vm._v("Paused On:")]), _vm._v(" " + _vm._s(_vm.formatDateTime(_vm.companyData.pause_date)) + " ")]) : _vm._e(), (_vm$companyData14 = _vm.companyData) !== null && _vm$companyData14 !== void 0 && _vm$companyData14.resume_date ? _c('p', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Resumed On:")]), _vm._v(" " + _vm._s(_vm.formatDateTime(_vm.companyData.resume_date)) + " ")]) : _vm._e()], 1)], 1)], 1), _c('b-card', [_c('div', [_c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "mode": "remote",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "columns": _vm.columns,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'created_at',
          type: 'desc'
        }]
      },
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$column2, _props$row, _props$row$currency, _props$column3, _props$column4;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_created_at' ? [props.row.created_at ? _c('div', [_vm._v(" " + _vm._s(_vm.formatDateTime(props.row.created_at)) + " ")]) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_amount' ? [props.row.amount_paid ? _c('div', [_c('div', [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : (_props$row$currency = _props$row.currency) === null || _props$row$currency === void 0 ? void 0 : _props$row$currency.toUpperCase()) + " " + _vm._s(props.row.amount_paid) + " ")])]) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) === 'format_next_payment_date' ? [props.row.next_payment_date ? _c('div', [_vm._v(" " + _vm._s(_vm.formatDateTime(props.row.next_payment_date)) + " ")]) : _vm._e()] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column4 = props.column) === null || _props$column4 === void 0 ? void 0 : _props$column4.field) === 'format_status' ? [_c('b-badge', {
          attrs: {
            "variant": "light-success"
          }
        }, [_vm._v(" " + _vm._s(props.row.payment_status) + " ")])] : _vm._e()];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }